export function scrollOverAmountElement(e: Event, amount = 0.8) {
    const { scrollTop, offsetHeight, scrollHeight } = e.target as HTMLElement;
    return Math.round(scrollTop) + offsetHeight > scrollHeight * amount;
}
